
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.234 6.082a.907.907 0 00-1.285 0l-4.183 5.276a.908.908 0 000 1.285l4.183 5.276a.91.91 0 001.285-1.285l-3.536-4.638 3.536-4.63a.916.916 0 000-1.284z"}})])
          )
        }
      }
    